import api from './api';

/**
 * Social Service
 * Handles social networking features
 */
export const socialService = {
  // ==================== Feed ====================
  
  /**
   * Get social feed
   */
  async getFeed(params) {
    const queryString = new URLSearchParams(params).toString();
    return api.get(`/v1/social/feed?${queryString}`);
  },

  /**
   * Get personalized feed
   */
  async getPersonalizedFeed(params) {
    const queryString = new URLSearchParams(params).toString();
    return api.get(`/v1/social/feed/personalized?${queryString}`);
  },

  // ==================== Posts ====================
  
  /**
   * Get post details
   */
  async getPost(postId) {
    return api.get(`/v1/social/posts/${postId}`);
  },

  /**
   * Create post
   */
  async createPost(postData) {
    return api.post('/v1/social/posts', postData);
  },

  /**
   * Update post
   */
  async updatePost(postId, postData) {
    return api.put(`/v1/social/posts/${postId}`, postData);
  },

  /**
   * Delete post
   */
  async deletePost(postId) {
    return api.delete(`/v1/social/posts/${postId}`);
  },

  /**
   * Share post
   */
  async sharePost(postId, shareData) {
    return api.post(`/v1/social/posts/${postId}/share`, shareData);
  },

  // ==================== Likes ====================
  
  /**
   * Like post
   */
  async likePost(postId) {
    return api.post(`/v1/social/posts/${postId}/like`);
  },

  /**
   * Unlike post
   */
  async unlikePost(postId) {
    return api.delete(`/v1/social/posts/${postId}/like`);
  },

  /**
   * Get post likes
   */
  async getPostLikes(postId, params) {
    const queryString = new URLSearchParams(params).toString();
    return api.get(`/v1/social/posts/${postId}/likes?${queryString}`);
  },

  // ==================== Comments ====================
  
  /**
   * Get post comments
   */
  async getComments(postId, params) {
    const queryString = new URLSearchParams(params).toString();
    return api.get(`/v1/social/posts/${postId}/comments?${queryString}`);
  },

  /**
   * Create comment
   */
  async createComment(postId, commentData) {
    return api.post(`/v1/social/posts/${postId}/comments`, commentData);
  },

  /**
   * Update comment
   */
  async updateComment(commentId, commentData) {
    return api.put(`/v1/social/comments/${commentId}`, commentData);
  },

  /**
   * Delete comment
   */
  async deleteComment(commentId) {
    return api.delete(`/v1/social/comments/${commentId}`);
  },

  // ==================== Bookmarks ====================

  /**
   * Get bookmarked posts
   */
  async getBookmarkedPosts(params) {
    const queryString = new URLSearchParams(params).toString();
    return api.get(`/v1/social/posts/bookmarked?${queryString}`);
  },

  /**
   * Bookmark post
   */

  /**
   * Bookmark post
   */
  async bookmarkPost(postId) {
    return api.post(`/v1/social/posts/${postId}/bookmark`);
  },

  /**
   * Unbookmark post
   */
  async unbookmarkPost(postId) {
    return api.delete(`/v1/social/posts/${postId}/bookmark`);
  },

  // ==================== Topics ====================

  /**
   * Get trending topics
   */
  async getTrendingTopics() {
    return api.get('/v1/social/topics/trending');
  },

  /**
   * Get predefined topics for post creation
   */
  async getPredefinedTopics() {
    return api.get('/v1/social/topics/predefined');
  },

  /**
   * Get trending posts
   */
  async getTrendingPosts(params) {
    const queryString = new URLSearchParams(params).toString();
    return api.get(`/v1/social/trending?${queryString}`);
  },

  // ==================== Activity ====================
  
  /**
   * Get user activity
   */
  async getUserActivity(userId, params) {
    const queryString = new URLSearchParams(params).toString();
    return api.get(`/v1/social/users/${userId}/activity?${queryString}`);
  },

  /**
   * Get own activity
   */
  async getMyActivity(params) {
    const queryString = new URLSearchParams(params).toString();
    return api.get(`/v1/social/my-activity?${queryString}`);
  },

  // ==================== Content Moderation ====================
  
  /**
   * Report content
   */
  async reportContent(contentData) {
    return api.post('/v1/social/report', contentData);
  },

  /**
   * Block user
   */
  async blockUser(userId) {
    return api.post(`/v1/social/users/${userId}/block`);
  },

  /**
   * Unblock user
   */
  async unblockUser(userId) {
    return api.delete(`/v1/social/users/${userId}/block`);
  },

  /**
   * Get blocked users
   */
  async getBlockedUsers() {
    return api.get('/v1/social/blocked-users');
  },
};

export default socialService;
